import { useState } from 'react'
import Collapse from '@mui/material/Collapse'
import { makeStyles } from '@material-ui/core/styles'
import { Text } from '../../components/1elements'
import CollapseArrowIcon from '../../components/1elements/Icons/js/CollapseArrowIcon'

const CollapsableContainerForLeftCard = ({
  contentClassName,
  text,
  children
}) => {
  const classes = useStyles()
  const [toggle, setToggle] = useState(true)

  return (
    <div className={classes.root}>
      <div className={classes.collapsableHeader}>
        <CollapseArrowIcon
          className={classes.collapsableArrow}
          toggle={toggle}
          setToggle={setToggle}
        />
        <Text type='h2'>{text}</Text>
      </div>
      <Collapse
        className={`${classes.collapsableContent} ${contentClassName}`}
        in={toggle}
        timeout='auto'
        unmountOnExit
      >
        {children}
      </Collapse>
    </div>
  )
}

export default CollapsableContainerForLeftCard

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  collapsableHeader: {
    height: '32%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '2px',
    width: '100%',
    padding: '5px',
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  },
  collapsableContent: {
    width: '100%',
    padding: '10px 10px 10px 15px'
  },
  collapsableArrow: {
    color: theme.palette.primary.accent
  }
}))
